var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99905 5.70711L1.1455 0.853553C0.830513 0.538571 1.0536 0 1.49905 0H14.499C14.9445 0 15.1676 0.538571 14.8526 0.853553L9.99905 5.70711V11.5C9.99905 11.6672 9.9155 11.8233 9.7764 11.916L6.7764 13.916C6.44412 14.1375 5.99905 13.8993 5.99905 13.5V5.70711ZM13.2919 1H2.70616L6.8526 5.14645C6.94637 5.24021 6.99905 5.36739 6.99905 5.5V12.5657L8.99905 11.2324V5.5C8.99905 5.36739 9.05173 5.24021 9.1455 5.14645L13.2919 1Z",
    fill: "#007CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.59953e8302760eb04092b30e4941917e.svg";
export { ForwardRef as ReactComponent };